import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
    selector: 'table-wrapper',
    templateUrl: './table.component.html',
})
export class TableWrapperComponent extends FieldWrapper {
}
